import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../ui/upload/uploadfile.component';
import {environment} from '../../../../environments/environment';
import {ToastrService} from 'ngx-toastr';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {language} from '../../../language/vn';
import {CommandUtil} from '../../../global/commandutil';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {Subject} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Sessioncommand} from '../../../global/sessioncommand';
import {NavItemService} from '../../../service/staff/service-navitem';
import {ThongBaoFileXuLyService} from '../../../service/info/service-thongbaofilexuly';
import {ThongBaoService} from '../../../service/info/service-thongbao';
import {CkEditorUploadAdapter} from '../../../global/upload-ckeditor';
@Component({
  templateUrl: './ykien.component.html',

})
export class YKienThongBaoComponent implements OnInit, AfterViewInit {
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public id: number = -1;
  public language = language;
  public showAction = true;
  public frmGroup: FormGroup;
  public onClose: Subject<boolean>;
  public editor = ClassicEditor;
  public submitValidate = false;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[]=[];
  public permissionAdmin: boolean =false;
  constructor(
    public toastr: ToastrService,
    public formBuilder: FormBuilder,
    public bsModalService: BsModalService,
    public _bsModalRef: BsModalRef,
    public commandUtil: CommandUtil,
    public thongBaoFileXuLyService: ThongBaoFileXuLyService,
    public navItemService: NavItemService,
    public thongBaoService: ThongBaoService
  ) {
  }
  ngAfterViewInit() {

  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }

  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      id: new FormControl(this.id),
      traLoi: new FormControl(),
      trangThai: new FormControl(),
      staffId: new FormControl()

    });
    this.frmGroup = this.formBuilder.group({
      id: ['', Validators.nullValidator],
      traLoi: ['', Validators.nullValidator],
      trangThai: ['', Validators.nullValidator],
      staffId: ['', Validators.nullValidator]
    });
    this.uploadUrl= this.thongBaoFileXuLyService.urlUpload;
    this.deleteUrl= this.thongBaoFileXuLyService.urlDelete;

  }
  public edit(id: number) {
    this.id = id;

  }
  public onReady( editor ) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
    editor.editing.view.change( writer => {
      writer.setStyle( 'height', '300px', editor.editing.view.document.getRoot() );
      writer.setStyle( 'border', '1px solid', editor.editing.view.document.getRoot() );
    } );
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return new CkEditorUploadAdapter(loader);
    };
  }
  public actionYKien ()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
       language.question_save_ykien,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.frmGroup.value.id = this.id;
        this.frmGroup.value.trangThai = 1;
        this.frmGroup.value.staffId = Sessioncommand.staffId;
        this.thongBaoService.updateXuLy(this.frmGroup.value).subscribe(
          {    next: (data) => {
              if(data !== -1) {
                this.uploadFileComponent.id = data;
                this.uploadFileComponent.uploadCommand.upload(this.uploadFileComponent.uploadCommand.getFilesData());
                this.toastr.success(language.message_ykien_success, language.message);
              }else
                this.toastr.warning(language.error_message_success, language.message);
              this.onSave();
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          });
      }
    });
  }

  public onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
    this.actionYKien();
  }
  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
}

